import { lazy } from 'react';
import { RouteObject } from 'react-router';

// project import
import Loadable from 'components/Loadable';

// render pages
const PartnerList = Loadable(lazy(() => import('pages/partner/List')));
const PartnerView = Loadable(lazy(() => import('pages/partner/View')));
const PartnerEdit = Loadable(lazy(() => import('pages/partner/Edit')));
const PartnerCmsEdit = Loadable(lazy(() => import('pages/partner/Cms')));
const PartnerCreate = Loadable(lazy(() => import('pages/partner/Create')));

const CategoryList = Loadable(
    lazy(() => import('pages/partner/categories/List')),
);

// ==============================|| PARTNER SUB ROUTING ||============================== //
const PartnerRoutes: RouteObject = {
    path: 'partner',
    children: [
        {
            path: '',
            element: <PartnerList />,
        },
        {
            path: ':id',
            element: <PartnerView />,
        },
        {
            path: ':id/edit',
            element: <PartnerEdit />,
        },
        {
            path: ':id/cms',
            element: <PartnerCmsEdit />,
        },
        {
            path: 'categories',
            element: <CategoryList />,
        },
        {
            path: 'new',
            element: <PartnerCreate />,
        },
    ],
};
export default PartnerRoutes;
